import throttle from 'lodash/throttle'

export default {
  computed: {
    hasSubscribed: function () {
      return this.isLoggedIn && this.project ? this.$store.getters.subscribedToProject(this.project.id, this.currentUser.userName) : false
    },
    params: function () {
      return { id: this.project.id, username: this.currentUser.userName }
    }
  },
  methods: {
    canSubscribe: function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'projectsubscribe:' + this.projectID, onSuccess: this.toggleSubscribe, signupMessage: 'Sign up to bookmark this story' })
      }
      this.toggleSubscribe()
    },
    toggleSubscribe: throttle(function () {
      if (this.hasSubscribed) {
        this.$store.dispatch('unsubscribeToProject', this.params)
      } else {
        this.$store.dispatch('subscribeToProject', this.params)
      }
    }, 500, { leading: true, trailing: false })
  }
}
